module.exports = __webpack_public_path__ + "static/media/2.94652714.svg";